import { render, staticRenderFns } from "./BusEntityinfo.vue?vue&type=template&id=306492be&scoped=true"
import script from "./BusEntityinfo.vue?vue&type=script&lang=js"
export * from "./BusEntityinfo.vue?vue&type=script&lang=js"
import style0 from "./BusEntityinfo.vue?vue&type=style&index=0&id=306492be&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "306492be",
  null
  
)

export default component.exports